export default function Card(): JSX.Element {
  return (
    <div className="swiper-slide swiper-slide--loader">
      <div className="m-card">
        <div className="m-card__wrapper">
          <div className="m-card__top">
            <div>
              <p className="m-card__label">
                <span></span>
              </p>
            </div>
            <div className="m-card__logo m-card__logo--80">
              <img src="" loading="lazy" alt="" />
            </div>
          </div>
          <div className="m-card__image">
            <img src="" loading="lazy" className="m-card__img" alt="" />
          </div>
          <div className="m-card__description">
            <div className="m-card__name"></div>
          </div>
          <div className="m-card__bottom">
            <div className="m-card__price m-price">
              <div className="m-price__old"></div>
              <div className="m-price__new"></div>
            </div>
            <div className="m-card__btn">
              <div className="m-card__more m-btn">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}